const characterKey = "impersonate.app:characterHistory";
const activityKey = "impersonate.app:activityHistory";

//
// Character history
//

export const getCharacterHistory = (): string[] => {
  try {
    const value = localStorage.getItem(characterKey);
    const arr = JSON.parse(value || "[]");
    if (Array.isArray(arr) && arr.every((item) => typeof item === "string")) {
      return arr;
    }
  } catch (err) {
    // Do nothing
  }
  return [];
};

export const saveCharacterHistory = (items: string[]) => {
  localStorage.setItem(characterKey, JSON.stringify(items));
};

export const clearCharacterHistory = () => {
  localStorage.removeItem(characterKey);
};

//
// Activity history
//

export const getActivityHistory = (): string[] => {
  try {
    const value = localStorage.getItem(activityKey);
    const arr = JSON.parse(value || "[]");
    if (Array.isArray(arr) && arr.every((item) => typeof item === "string")) {
      return arr;
    }
  } catch (err) {
    // Do nothing
  }
  return [];
};

export const saveActivityHistory = (items: string[]) => {
  localStorage.setItem(activityKey, JSON.stringify(items));
};

export const clearActivityHistory = () => {
  localStorage.removeItem(activityKey);
};

//
// Clear history
//

export const clearHistory = () => {
  // Old history key
  localStorage.removeItem("impersonate.io:history");

  clearCharacterHistory();
  clearActivityHistory();
};
